import { render, staticRenderFns } from "./WordingType.vue?vue&type=template&id=1751c366&scoped=true&"
import script from "./WordingType.vue?vue&type=script&lang=js&"
export * from "./WordingType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1751c366",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VDataTable,VFlex,VLayout})
